import M from "moment";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import {filterConfig} from "../config/config";
import Api from "../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {mapToObjectDDL} from "../../../../common/mapper";

class InventoryFilter extends Component {
    constructor(props) {
        super(props);
        this.filterInputConfig = filterConfig[props.tab];
        this.state = {
            loading: false,
            dataTable: [],
            dataLocator: [],
            dataKsu: [],
            dataKategoriKSU: [],
        };
    }

    componentDidMount = async () => {
        await this.fetchDataKsu();
        await this.fetchDataLocator();
        await this.fetchDataCategoryKSU();
    }

    handleSubmit = () => {
        this.props.onSubmit();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataKsu = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllKSU();
            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataKsu: res.data.data,
                }))
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataLocator = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: { kodeCabang: this.props.selectedCabang?.value },
                page: null,
                limit: null
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataLocator: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataCategoryKSU = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam({
                paramFilters: { bizparCategory: "KSU_TYPE" },
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataKategoriKSU: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    render() {
        const {visible, onClickClose} = this.props;
        return (
            <SimpleModal
                title="Filter Search"
                visible={visible}
                onClickClose={onClickClose}
                content={
                    <ModalContainer>
                            <FlexView column>
                                <FlexView column vAlignContent="center">
                                    <p>{this.filterInputConfig.dateLabel}</p>
                                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                        <SimpleDate
                                            date={this.props.filteredData.startSPBK}
                                            onChange={(value) =>
                                                this.props.onValueChange("startSPBK", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                        <span className="margin-bottom-20px">To</span>
                                        <SimpleDate
                                            date={this.props.filteredData.endSPBK}
                                            onChange={(value) =>
                                                this.props.onValueChange("endSPBK", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                    </FlexView>
                                </FlexView>
                                <SimpleInput
                                    name={this.filterInputConfig.noName}
                                    label={this.filterInputConfig.noLabel}
                                    value={this.props.filteredData.noSPBK}
                                    onChange={({target}) =>
                                        this.props.onValueChange(target.name, target.value?.trim())
                                    }
                                />
                                <FlexView column>
                                    <p>Tanggal SPBM:</p>
                                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                        <SimpleDate
                                            date={this.props.filteredData.startSPBM}
                                            onChange={(value) =>
                                                this.props.onValueChange("startSPBM", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                        <span className="margin-bottom-20px">To</span>
                                        <SimpleDate
                                            date={this.props.filteredData.endSPBM}
                                            onChange={(value) =>
                                                this.props.onValueChange("endSPBM", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                    </FlexView>
                                </FlexView>
                                <SimpleInput
                                    name="noSPBM"
                                    label="No. SPBM"
                                    value={this.props.filteredData.noSPBM}
                                    onChange={({target}) => this.props.onValueChange(target.name, target.value?.trim()?.toUpperCase())
                                    }
                                />
                                <h3>Filter Detail</h3>
                                <SimpleDDL
                                    id={`select_options_${this.filterInputConfig.codeName}`}
                                    box="search"
                                    label={this.filterInputConfig.codeLabel}
                                    name={this.filterInputConfig.codeName}
                                    isClearable={true}
                                    options={this.state.dataKsu ? this.state.dataKsu.map(
                                        item => mapToObjectDDL(
                                            `${item.kodeKSU} - ${item.name}`,
                                            item.kodeKSU
                                        )) : null}
                                    value={this.props.filteredData.kodeKSU}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                                <SimpleDDL
                                    id={`select_options_${this.filterInputConfig.categoryName}`}
                                    box="search"
                                    label={this.filterInputConfig.categoryLabel}
                                    name={this.filterInputConfig.categoryName}
                                    isClearable={true}
                                    options={this.state.dataKategoriKSU ? this.state.dataKategoriKSU.map(
                                        item => mapToObjectDDL(
                                            item.value,
                                           item.key
                                        )) : null}
                                    value={this.props.filteredData.kategoriKSU}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                                <SimpleDDL
                                    id="select_options_locator"
                                    box="search"
                                    label="Locator"
                                    name="idLocator"
                                    isClearable={true}
                                    options={this.state.dataLocator ? this.state.dataLocator.map(
                                        item => mapToObjectDDL(
                                            item.nameLocation,
                                            item.kodeLocation
                                        )) : null}
                                    value={this.props.filteredData.idLocator}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                            </FlexView>
                            <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton
                                    type="button"
                                    secondary
                                    onClick={this.props.onClearFilter}
                                >
                                    Clear
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </FlexView>

                        <SimpleLoadingOverlay active={this.state.loading}/>
                    </ModalContainer>
                }
            />
        );
    }
}

export default InventoryFilter;
